'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mixSelectableParent = require('../utils/mix-selectable-parent.js');

exports.default = {
  mixins: [(0, _mixSelectableParent.mixSelectableParent)('dof-tag-group')]
}; //
//
//
//
//
//


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/script-loader.js!./~/babel-loader/lib!./~/weex-vue-loader/lib/selector.js?type=script&index=0!./packages/dof-tag-group/index.vue
// module id = 407
// module chunks = 0 1